import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FontSizeOption = 'medium' | 'large';

// UI-only settings state
export interface SettingsState {
  messageFontSize: FontSizeOption;
}

const initialState: SettingsState = {
  messageFontSize: 'medium',
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setMessageFontSize: (state, action: PayloadAction<FontSizeOption>) => {
      state.messageFontSize = action.payload;
    },
  },
});

export const {
  setMessageFontSize,
} = settingsSlice.actions;

export default settingsSlice.reducer;
